export const vacationTypes = {
  isVacation: { letter: "О", title: "Основной отпуск" },
  isMainVacation: { letter: "О", title: "Основной отпуск" },
  isChildVacation: { letter: "ОР", title: "Отпуск по уходу за ребенком" },
  isUnpaidLeave: { letter: "ОБ", title: "Отпуск без сохранения оплаты" },
  isAddVacation: { letter: "ДО", title: "Дополнительный отпуск" },
  isAbsence: { letter: "НН", title: "Неявка" },
  isSickLeave: { letter: "Б", title: "Больничный лист" },
  isMission: { letter: "К", title: "Командировка" },
  isDowntime: { letter: "П", title: "Простой" },
  isPersTransfer: { letter: "КП", title: "Кадровый перевод" },
  isVacationSchedule: { letter: "ОГ", title: "График отпуска" }
} as const;

export type VacationFlag = keyof typeof vacationTypes